import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3sbdu0huip: FaireBrandEntity = {
  token: "b_3sbdu0huip",
  type: "brand",
  name: "MUD WITCH",
  avatarUrl:
    "https://cdn.faire.com/fastly/970a51fc1eb69b47730a8871301740af55a3edabef89b351bc53e9df3b7be6d7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bbf2ff3ec5611e3a6e3a75b914fded2970187016f6fecdf2837315617dda3356.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/970a51fc1eb69b47730a8871301740af55a3edabef89b351bc53e9df3b7be6d7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bbf2ff3ec5611e3a6e3a75b914fded2970187016f6fecdf2837315617dda3356.jpeg",
  location: "San francisco, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 7,
  isInsider: true,
  description:
    "My name is Viviana Matsuda and I am a queer Japanese/Mexican Artist from San Francisco. My dad was a ceramicist and when he passed away I was left with a bunch of pottery supplies. I took a ceramics class as a creative outlet to work through my grief. Using only my hands to turn earth was therapeutic. I spent hours making all sorts of random forms with no intentions. Some are chubby like me and have uneven curves. The colorful pieces are smooth or ruff, some have freckles, and are all so beautiful in their diversity.\n\nMy business has grown and is now a full blown pottery production and have a small team. I still do all the wheel throwing and we are working through casting my handmade pieces to share my designs with more folks and and to free me to create new work.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:49.214Z",
    importedBy: "entity-db-cli",
  },
};
